import { FC } from 'react';
import { CatButton } from '@blocks-react/components/Button';
import { CatIconEmail } from '@blocks-react/components/Icons/Email';
import { CatIconPhone } from '@blocks-react/components/Icons/Phone';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatTextPassage } from '@blocks-react/components/TextPassage';
import { CatIconNewspaper } from '@blocks-react/components/Icons/Newspaper';
import { CatStatusIndicator } from '@blocks-react/components/StatusIndicator';
import { CatIconArrowBack } from '@blocks-react/components/Icons/ArrowBack';
import { ContactDealerProps } from '../types';
import styles from '../NotificationDrawer.module.scss';

export const ContactDealer: FC<ContactDealerProps> = ({
  children,
  SOS_CONTACT_DEALER,
  orderStatus,
  type,
  NOTIFICATION_CONTACT_DEALER_MESSAGE,
  dealerName,
  name,
  address,
  state,
  zipcode,
  email,
  isMD,
  handleClickClose,
  EMAIL_US,
  phone,
  formateMobileNumber,
  CANCEL,
  closeDrawer,
  backButtonAriaLable
}) => {
  return (
    <>
    <div slot="header" className="d-flex align-items-center">
        <CatButton
          hideText
          onClick={() => closeDrawer()}
          size="sm"
          variant="ghost"
        >
          <CatIconArrowBack slot="before" aria-label={backButtonAriaLable}/>
        </CatButton>
      <CatHeading variant="title" slot="header"  className="ms-3" aria-label={SOS_CONTACT_DEALER}>
        {SOS_CONTACT_DEALER}
      </CatHeading>
      </div>
      <div className="d-flex mt-lg-4">
        <CatIconNewspaper />
        <div className="ms-2 ">{children}</div>
      </div>
      <div className="ms-4 mt-2">
        <CatStatusIndicator
          text={orderStatus}
          variant={type}
          data-testid="statuslabel"
        />
      </div>
      <p className={`ms-4 mt-2 ${styles['contact-dealer-address']}`}>
        {NOTIFICATION_CONTACT_DEALER_MESSAGE}
      </p>
      <hr></hr>
      <CatTextPassage className="p-20">
        <p className={`${styles['contact-dealer-name']} text-capitalize`}>
          {dealerName?.toLowerCase()}
        </p>
        <p className={`${styles['contact-dealer-location']} text-capitalize`}>
          {name?.toLowerCase()}
        </p>
        <p className={`${styles['contact-dealer-address']} text-capitalize`}>
          {address?.toLowerCase()},{state?.toLowerCase()} {zipcode}
        </p>
      </CatTextPassage>
      <div className={`${styles['contact-dealer-btngroup']}`}>
        <CatButton
          variant="primary"
          href={`mailto:${email}`}
          data-testid="email-us-button"
          fullWidth={!isMD}
          className={!isMD ? 'w-100' : ''}
          onClick={handleClickClose}
        >
          <CatIconEmail slot="before"/> {EMAIL_US}
        </CatButton>
        <CatButton
          href={`tel:${phone}`}
          data-testid="call-us-button"
          fullWidth={!isMD}
          className={!isMD ? 'w-100' : ''}
          onClick={handleClickClose}
        >
          <CatIconPhone slot="before" aria-label={formateMobileNumber}/>
          {formateMobileNumber}
        </CatButton>
      </div>
      <div slot="footer">
        <CatButton variant="inline" onClick={handleClickClose} aria-label={CANCEL}>
          {CANCEL}
        </CatButton>
      </div>
    </>
  );
};
